import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';

import getOperatorTask from './useOperatorTask.request';

import { OperatorTask } from 'modules/common/components/MemberOperator/MemberOperator.interfaces';
import { OPERATOR_TASKS_KEY } from 'services/operatorTasks/queries/useOperatorTasks/queryKeys';

/** @public */
export default function useOperatorTask(
    taskId: string | undefined,
    options?: Omit<UseQueryOptions<OperatorTask, Error>, 'queryKey' | 'queryFn'>
) {
    return useQuery({
        queryKey: [OPERATOR_TASKS_KEY, taskId],
        queryFn: taskId ? () => getOperatorTask(taskId) : skipToken,
        ...options,
    });
}
